import React, { useRef, useState, useEffect } from 'react';
import { Menu } from 'antd';
import copy from 'copy-to-clipboard';
import LxPopover from '@web-common/components/UI/LxPopover/LxPopover';
import styles from './index.module.scss';
import classnames from 'classnames';
import { getIn18Text } from 'api';
const InputContextMenu = props => {
    const { children, changeVal, inputOutRef } = props;
    const [visible, setVisible] = useState(false);
    const [onlyPaste, setOnlyPaste] = useState(true);
    const [pos, setPos] = useState({
        top: 0,
        left: 0,
    });
    const inputRef = useRef(null);
    const toggleContextMenuRef = useRef(null);
    const [inputRefFlag, setInputRefFlag] = useState(0);
    const contextMenuFn = e => {
        e.preventDefault();
        let inputEle = inputRef.current;
        if (inputEle) {
            setOnlyPaste(inputEle.selectionStart === inputEle.selectionEnd);
        }
        setVisible(true);
        setPos({ top: e.clientY, left: e.clientX });
    };
    const setNativeValue = (element, value, lastValue) => {
        element.value = value;
        let event = new Event('input', { bubbles: true });
        event.simulated = true;
        let tracker = element._valueTracker;
        if (tracker) {
            tracker.setValue(lastValue);
        }
        element.dispatchEvent(event);
    };
    const changeInputVal = (inputEle, newValue, val) => {
        setTimeout(() => {
            inputEle.focus();
            changeVal && changeVal(newValue);
            setVisible(false);
            setNativeValue(inputEle, newValue, val);
        }, 300);
    };
    const onTagCopy = () => {
        if (!inputRef.current)
            return;
        let inputEle = inputRef.current;
        const val = (inputEle === null || inputEle === void 0 ? void 0 : inputEle.value) === undefined ? '' : inputEle === null || inputEle === void 0 ? void 0 : inputEle.value;
        if (val) {
            copy(val.slice(inputEle.selectionStart, inputEle.selectionEnd));
        }
    };
    const onTagCut = () => {
        if (!inputRef.current)
            return;
        let inputEle = inputRef.current;
        const val = (inputEle === null || inputEle === void 0 ? void 0 : inputEle.value) === undefined ? '' : inputEle === null || inputEle === void 0 ? void 0 : inputEle.value;
        if (val) {
            copy(val.slice(inputEle.selectionStart, inputEle.selectionEnd));
            const newValue = val.slice(0, inputEle.selectionStart) + val.slice(inputEle.selectionEnd);
            changeInputVal(inputEle, newValue, val);
        }
    };
    const onTagPaste = async (e) => {
        if (!inputRef.current)
            return;
        let inputEle = inputRef.current;
        const val = (inputEle === null || inputEle === void 0 ? void 0 : inputEle.value) === undefined ? '' : inputEle === null || inputEle === void 0 ? void 0 : inputEle.value;
        if (inputEle) {
            const clipboardData = await navigator.clipboard.readText();
            const newValue = val.slice(0, inputEle.selectionStart) + clipboardData + val.slice(inputEle.selectionEnd);
            changeInputVal(inputEle, newValue, val);
        }
    };
    const hideMenu = () => {
        setVisible(false);
    };
    useEffect(() => {
        if (!toggleContextMenuRef.current)
            return;
        let toggleEle = toggleContextMenuRef.current;
        toggleEle.addEventListener('contextmenu', contextMenuFn);
        document.addEventListener('click', hideMenu);
        return () => {
            toggleEle.removeEventListener('contextmenu', contextMenuFn);
            document.removeEventListener('click', hideMenu);
        };
    }, [hideMenu, contextMenuFn, inputRefFlag]);
    useEffect(() => {
        const timer = setInterval(() => {
            var _a, _b;
            if (inputOutRef === null || inputOutRef === void 0 ? void 0 : inputOutRef.current) {
                clearInterval(timer);
                if ((_a = inputOutRef.current) === null || _a === void 0 ? void 0 : _a.input) {
                    inputRef.current = inputOutRef.current.input;
                    toggleContextMenuRef.current = inputOutRef.current.input;
                }
                if ((_b = inputOutRef.current) === null || _b === void 0 ? void 0 : _b.resizableTextArea) {
                    inputRef.current = inputOutRef.current.resizableTextArea.textArea;
                    toggleContextMenuRef.current = inputOutRef.current.resizableTextArea.textArea;
                }
                if (inputOutRef.current && inputOutRef.current instanceof HTMLElement) {
                    const refTagName = inputOutRef.current.tagName;
                    toggleContextMenuRef.current = inputOutRef.current;
                    if (['INPUT', 'TEXTAREA'].includes(refTagName)) {
                        inputRef.current = inputOutRef.current;
                    }
                    else {
                        const mayInput = inputOutRef.current.querySelector('input');
                        const mayText = inputOutRef.current.querySelector('textarea');
                        inputRef.current = mayInput || mayText;
                    }
                }
                setInputRefFlag(pre => ++pre);
            }
        }, 300);
        return () => {
            clearInterval(timer);
        };
    }, [children]);
    return (React.createElement(React.Fragment, null,
        children,
        React.createElement(LxPopover, { top: pos.top, left: pos.left, visible: visible },
            React.createElement(Menu, { className: classnames(styles.menu, 'sirius-no-drag') },
                React.createElement(Menu.Item, { onClick: onTagCopy, hidden: onlyPaste }, getIn18Text('FUZHI')),
                React.createElement(Menu.Item, { onClick: onTagCut, hidden: onlyPaste }, getIn18Text('JIANQIE')),
                React.createElement(Menu.Item, { onClick: onTagPaste }, getIn18Text('ZHANTIE'))))));
};
export default InputContextMenu;
